<template>
  <section class="hp-section hp-cities hp-animate">
    <div class="container">
      <div class="hp-section__head hp-section__head--center">
        <h2 class="hp-section__title">Jobs from popular cities</h2>
        <p class="hp-section__subtitle">Explore openings in India's top job hubs</p>
      </div>
      <div class="hp-cities__scroll">
        <a
          v-for="city in cities"
          :key="city.href"
          :href="city.href"
          class="hp-city-tile"
          :class="{ 'hp-city-tile--more': city.isMore }"
          target="_blank"
          rel="noopener"
        >
          <div class="hp-city-tile__icon">
            <img
              :src="$S3_url + city.image"
              :alt="city.isMore ? 'More cities' : 'Jobs in ' + city.name"
              loading="lazy"
            />
          </div>
          <span class="hp-city-tile__name">
            <template v-if="city.isMore"><span class="hp-city-tile__count">800+</span> cities</template>
            <template v-else>{{ city.name }}</template>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePopularCities',
  props: {
    cities: { type: Array, default: () => [] },
  },
};
</script>
